var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuwang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4009_3489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10C9.5 6 13 3.5 15.5 3.5",
    stroke: "#595959",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5H15.2069",
    stroke: "#595959",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0V16M6 0L6 16M2 0L2 16",
    stroke: "#595959",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5H16",
    stroke: "#595959",
    strokeDasharray: "1 1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4009_3489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuwang);
export default __webpack_public_path__ + "static/media/luwang.6075e0900d7b4905d2deab1cfd7f0ecd.svg";
export { ForwardRef as ReactComponent };